import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CHECK_CHIUSURE_FEATURE_KEY,
  CheckBilanciState,
} from './check-bilanci.reducer';

export const getCheckBilanciState = createFeatureSelector<CheckBilanciState>(
  CHECK_CHIUSURE_FEATURE_KEY
);

export const selectEsercizioChecked = createSelector(
  getCheckBilanciState,
  (s) => s.esercizioChecked
);

export const selectEsercizioClosed = createSelector(
  getCheckBilanciState,
  (s) => s.esercizioClosed
);

export const selectConsolidatoChecked = createSelector(
  getCheckBilanciState,
  (s) => s.consolidatoChecked
);

export const selectConsolidatoExists = createSelector(
  getCheckBilanciState,
  (s) => s.consolidatoExists
);

export const selectConsolidatoClosed = createSelector(
  getCheckBilanciState,
  (s) => s.consolidatoClosed
);

export const selectConsolidatoEnteId = createSelector(
  getCheckBilanciState,
  (s) => s.consolidatoEnteId
);

export const selectConsolidatoAnno = createSelector(
  getCheckBilanciState,
  (s) => s.consolidatoAnno
);

export const selectEsercizioEnteId = createSelector(
  getCheckBilanciState,
  (s) => s.esercizioEnteId
);

export const selectEsercizioAnno = createSelector(
  getCheckBilanciState,
  (s) => s.esercizioAnno
);

export const selectDatiRiepilogoModificati = createSelector(
  getCheckBilanciState,
  (s) => s.datiRiepilogoModificati
);

export const selectRiepilogoChecked = createSelector(
  getCheckBilanciState,
  (s) => s.riepilogoChecked
);
